import 'regenerator-runtime/runtime';
import { call, cancel, put, takeEvery } from 'redux-saga/effects';
import {
  ANTRAGSNUMMER_EVENTS,
  DoRequestResponse,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { ThhPferdActions } from '../thhPferdActions';

export function* watchAntragsnummerRequested() {
  yield takeEvery(
    GlobalActions.ANTRAGSNUMMER_REQUESTED,
    safeSaga(antragsnummerSaga, App.THH_PFERD),
  );
  yield takeEvery(
    ThhPferdActions.VORSCHLAGDATEN_CHANGED,
    safeSaga(antragsnummerSaga, App.THH_PFERD),
  );
  yield takeEvery(
    ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
    safeSaga(successCallback, App.THH_PFERD),
  );
}

export function* antragsnummerSaga(action: AnyAction) {
  if (
    action.payload?.appId === App.THH_PFERD ||
    action.type === ThhPferdActions.VORSCHLAGDATEN_CHANGED
  ) {
    const globalPut = GlobalPut.getInstance();

    yield call(
      globalPut.put.bind(globalPut),
      new GlobalActions().doRequestAntragsnummer(
        App.THH_PFERD,
        ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
        ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_FAILED,
        undefined,
        action.type === ThhPferdActions.VORSCHLAGDATEN_CHANGED ? action.payload : undefined,
      ),
    );
  }
}

export function* successCallback(successAction: DoRequestResponse<string>) {
  try {
    if (successAction.doRequestAction.payload.appId === App.THH_PFERD) {
      const globalPut = GlobalPut.getInstance();
      const antragsnummerAsString = successAction.payload.toString();
      yield put(new ThhPferdActions().antragsnummerGenerated(antragsnummerAsString));
      yield call(
        globalPut.put,
        new GlobalActions().antragsnummerGenerated(
          (successAction.doRequestAction.payload.additionalData as { deferTarifierung?: boolean })
            ?.deferTarifierung === true,
        ),
      );
    }
  } catch (exception) {
    PS20Logger.error(
      App.THH_PFERD,
      exception as Error,
      'AntragsnummerSaga successCallback Antragsnummer konnte nicht verarbeitet werden',
    );
    yield cancel();
  }
}
